import { render } from "./ReportCriterionAutocomplete.vue?vue&type=template&id=f5f20a1c&scoped=true"
import script from "./ReportCriterionAutocomplete.vue?vue&type=script&lang=js"
export * from "./ReportCriterionAutocomplete.vue?vue&type=script&lang=js"

import "./ReportCriterionAutocomplete.vue?vue&type=style&index=0&id=f5f20a1c&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5f20a1c"]])

export default __exports__